import { render } from "./SocialButton.vue?vue&type=template&id=f5d1f7dc&scoped=true"
import script from "./SocialButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialButton.vue?vue&type=script&setup=true&lang=js"

import "./SocialButton.vue?vue&type=style&index=0&id=f5d1f7dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d1f7dc"],['__file',"src/components/Utility/SocialButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5d1f7dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5d1f7dc', __exports__)) {
    api.reload('f5d1f7dc', __exports__)
  }
  
  module.hot.accept("./SocialButton.vue?vue&type=template&id=f5d1f7dc&scoped=true", () => {
    api.rerender('f5d1f7dc', render)
  })

}


export default __exports__